import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ["hoverBox"]

  enter(event) {
    this.hoverBoxTargets.forEach(el => {
      if (el == event.currentTarget) {
        el.classList.add("active")
      } else {
        el.classList.add("inactive")
      }
    })
  }

  leave(event) {
    this.hoverBoxTargets.forEach(el => {
      el.classList.remove("active")
      el.classList.remove("inactive")
    })
  }
}
